module.exports = __webpack_public_path__ + "img/team-v03.813cc266.png";